/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInChatResponseLastMessageDirection = typeof LinkedInChatResponseLastMessageDirection[keyof typeof LinkedInChatResponseLastMessageDirection] | null;


export const LinkedInChatResponseLastMessageDirection = {
  inbound: 'inbound',
  outbound: 'outbound',
} as const;
